/**
 * @generated SignedSource<<698ce2a98471a87410710c3c7c10230d>>
 * @relayHash 2f2525f72b335b5d911e7fb1e6f7b2df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ProductsAppQuery } from './ProductsAppQuery.graphql';

const node: PreloadableConcreteRequest<ProductsAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fff1b9db57164afdc2cb99db0a24791b15cff9d95476b7da66614db65e45d7a6",
    "metadata": {},
    "name": "ProductsAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
